import React from 'react';
import { connect } from 'react-redux';
import { bool } from 'prop-types';
import styles from './Uploading.less';

const Uploading = ({ isUploading }) => isUploading
  ? (
    <div className={styles.wrapper}>
      <div className={styles.meter}>
        <span>Processing upload image</span>
      </div>
    </div>
  ) : null;

Uploading.propTypes = {
  isUploading: bool.isRequired,
};

export default connect(
  state => ({
    isUploading: state.webChat.commons.uploading,
  }),
)(Uploading);
